import { integrationsApi } from '../../../../../shared/api';
import { integrationsModel } from '../../..';
import { call, put, select } from 'redux-saga/effects';
import { teamsModel } from '../../../../../features/teams';
import { RT } from '../../../../../shared/types';
import {
  HubspotObjectsData,
  SalesforceObjectsData,
} from '@distribute/shared/types';
import { createNotification } from '../../../../../features/snackbar';
import { snackbarModel } from '../../../../../features/snackbar';
import { AxiosError } from 'axios';
import { REFRESH_TOKEN_EXPIRATION_MESSAGE } from '@distribute/shared/types';

export function* searchCRMObjects({
  payload: { search },
}: ReturnType<typeof integrationsModel.actions.searchCRMObjects>) {
  try {
    yield put(integrationsModel.actions.setIsCRMObjectsLoading(true));

    const { id }: RT<typeof teamsModel.selectors.selectCurrentTeamWithError> =
      yield select(teamsModel.selectors.selectCurrentTeamWithError);

    const {
      salesforceObjects,
      hubspotObjects,
    }: {
      salesforceObjects: SalesforceObjectsData;
      hubspotObjects: HubspotObjectsData;
    } = yield call(integrationsApi.getCRMData, id, search);

    yield put(
      integrationsModel.actions.setSalesforceObjects(salesforceObjects)
    );

    yield put(integrationsModel.actions.setHubspotObjects(hubspotObjects));
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(
        snackbarModel.actions.addNotificationAction(
          createNotification('error', error.response?.data.message)
        )
      );
      if (error.response?.data.message === REFRESH_TOKEN_EXPIRATION_MESSAGE) {
        yield call(teamsModel.sagas.refreshTeamsData);
      }
    } else {
      yield put(
        snackbarModel.actions.addNotificationAction(
          createNotification('error', 'Failed to search Salesforce objects')
        )
      );
    }
  } finally {
    yield put(integrationsModel.actions.setIsCRMObjectsLoading(false));
  }
}
